export default "__VITE_ASSET__cb8f4b49__"